(function () {
  'use strict';
  const footers = new Map();

  function init(root) {
    root.querySelectorAll('[data-section-type="static-footer"]').forEach(marker => {
      const footer = marker.closest('.shopify-section');
      if (!footer || footers.has(footer)) return;
      const mobile = window.matchMedia('(max-width: 1023px)');
      const cleanups = [];
      footer.querySelectorAll('.site-footer-block-menu').forEach((block, index) => {
        const heading = block.querySelector('[data-accordion-trigger]');
        const content = block.querySelector('[data-accordion-content]');
        if (!heading || !content) return;
        // Keep Empire's section-selection/breakpoint classes, but own the trigger
        // so a native button and the legacy delegated click cannot toggle twice.
        heading.removeAttribute('data-accordion-trigger');
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'zt-footer-toggle';
        content.id = content.id || `${footer.id}-menu-${index}`;
        button.setAttribute('aria-controls', content.id);
        const sync = () => {
          const expanded = !mobile.matches || block.classList.contains('accordion--active');
          if (mobile.matches && !heading.contains(button)) {
            button.append(...heading.childNodes);
            heading.append(button);
          } else if (!mobile.matches && heading.contains(button)) {
            heading.append(...button.childNodes);
            button.remove();
          }
          button.setAttribute('aria-expanded', String(expanded));
          content.hidden = !expanded;
          if (block.classList.contains('zt-footer-menu-mobile') !== mobile.matches) {
            block.classList.toggle('zt-footer-menu-mobile', mobile.matches);
          }
        };
        button.addEventListener('click', () => {
          block.classList.toggle('accordion--active');
          sync();
        });
        const observer = new MutationObserver(sync);
        // Observe Empire's state changes, without observing our own aria/hidden.
        observer.observe(block, { attributes: true, attributeFilter: ['class'] });
        mobile.addEventListener('change', sync);
        sync();
        cleanups.push(() => {
          observer.disconnect();
          mobile.removeEventListener('change', sync);
        });
      });
      footers.set(footer, () => cleanups.forEach(cleanup => cleanup()));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const cleanup = footers.get(event.target);
    if (cleanup) { cleanup(); footers.delete(event.target); }
  });
})();
